module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/omni-3ed856431f869f64841aa20ccb60ba60.svg";